// extracted by mini-css-extract-plugin
export default {"root":"Testimonials_root__k7uqX","title":"Testimonials_title__fp-+s","slider":"Testimonials_slider__WhB9g","sliderButtons":"Testimonials_sliderButtons__6Lma6"};